import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { InputControlBase } from '../../../core/component/forms/input-control.base';
import { ContactIdKind } from '../../../rent/model/contact';
import { IdNumberValidatorService } from '../../service/id-number-validator-service';
import { LanguageService } from '../../../core/service/language.service';

@Component({
  selector: 'app-contact-id',
  templateUrl: './contact-id.component.html',
  styleUrls: ['./contact-id.component.scss'],
  providers: [IdNumberValidatorService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContactIdComponent extends InputControlBase {
  constructor(
    private _idValidationService: IdNumberValidatorService,
    private _languageService: LanguageService
  ) {
    super();
  }

  private autoTouch: boolean = false;

  @Input() set idType(type: ContactIdKind) {
    this.autoTouch = this._idType && this._idType !== type;
    this._idType = type;
    this.setValidator();
  }

  private appliedValidator: ValidatorFn | null = null;

  onControlSet() {
    super.onControlSet();
    this.setValidator();
  }

  private setValidator() {
    if (this.control) {
      if (this.appliedValidator) this.control.removeValidators(this.appliedValidator);

      this.appliedValidator = this.getValidator();
      if (this.appliedValidator) this.control.addValidators(this.appliedValidator);

      if (this.autoTouch) {
        this.control.markAsTouched();
      }
      this.control.updateValueAndValidity({ emitEvent: true });
    }
  }
  private getValidator(): ValidatorFn {
    switch (this.idType) {
      case ContactIdKind.SwedishSSN:
        return this._idValidationService.swedishSSN;
      case ContactIdKind.SwedishOrganizationNumber:
        return this._idValidationService.swedishOrganizationNumber;
      case ContactIdKind.BirthdayIso8601:
        return this._idValidationService.birthdayIso8601;
      case ContactIdKind.FreeText:
        return Validators.maxLength(255);
      default:
        return this.validationRegex ? Validators.pattern(this.validationRegex) : null;
    }
  }

  get idType(): ContactIdKind {
    return this._idType;
  }
  private _idType: ContactIdKind;

  get format(): string {
    return this._languageService.getText('TENANT.ID_TYPE.FORMAT.F' + this.idType.toString());
  }

  get validationRegex(): RegExp {
    switch (this.idType) {
      case ContactIdKind.SwedishSSN:
        return /^(\d{8}\-\d{4})$/;
      case ContactIdKind.SwedishOrganizationNumber:
      case ContactIdKind.SwedishCoordinationNumber:
      case ContactIdKind.DanishSSN:
        return /^(\d{6}\-\d{4})$/;
      case ContactIdKind.DanishOrganizationNumber:
        return /^(\d{8})$/;
      case ContactIdKind.FinnishSSN:
        return /^(\d{6}[+\-Aa]\d{3}[\dA-Za-z])$/;
      case ContactIdKind.FinnishOrganizationNumber:
        return /^(\d{7}-\d)$/;
      case ContactIdKind.NorwegianOrganizationNumber:
        return /^(\d{9})$/;
      case ContactIdKind.NorwegianSSN:
        return /^(\d{11})$/;
      case ContactIdKind.BirthdayIso8601:
        return /^(\d{8})$/;
      default:
        return null;
    }
  }
}
